import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-navy-900 text-slate-300 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 bg-gold-500 rounded flex items-center justify-center">
                <span className="text-navy-900 font-serif font-bold">K</span>
              </div>
              <span className="font-serif font-bold text-xl text-white">The Kajidori Collective</span>
            </div>
            <p className="text-slate-400 max-w-sm leading-relaxed mb-6">
              Strategic Leadership, Operational Clarity, and World-Class Excellence for UK Health & Social Care.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center hover:bg-slate-800 hover:text-white transition-colors">
                <SafeIcon name="Linkedin" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center hover:bg-slate-800 hover:text-white transition-colors">
                <SafeIcon name="Twitter" />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Navigation</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="hover:text-gold-500 transition-colors">About Yeukai</Link></li>
              <li><Link to="/services" className="hover:text-gold-500 transition-colors">Services</Link></li>
              <li><Link to="/case-studies" className="hover:text-gold-500 transition-colors">Case Studies</Link></li>
              <li><Link to="/contact" className="hover:text-gold-500 transition-colors">Contact</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Client Access</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/portal/login" className="hover:text-gold-500 transition-colors flex items-center gap-2">
                  <SafeIcon name="LogOut" className="w-4 h-4" />
                  The Kajidori Portal
                </Link>
              </li>
              <li><a href="#" className="hover:text-gold-500 transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-gold-500 transition-colors">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-800 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500">
          <p>&copy; {new Date().getFullYear()} The Kajidori Collective. All rights reserved.</p>
          <p className="mt-2 md:mt-0 flex items-center gap-1">
            Built for UK Care Leaders
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;